import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import Carousel from 'react-elastic-carousel';
import { useArticles } from '@app/hooks';
import ArticleItem from '@components/Articles/Article';
import { Container, Title } from './styles';
import { useCarouselScrollLock } from '@app/hooks/useCarouselScrollLock';
import { useScreenSize } from '@app/hooks/useScreenSize';

export interface ArticleCarouselProps {
  outerSpacing?: number;
  articleData?: any;
}

const ArticlesCarousel = ({ outerSpacing, articleData }: any) => {
  const { handleTouchMove, handleTouchStart } = useCarouselScrollLock();

  const { articleContent, groupId, articlesCarouselTitle } = useArticles({
    articleData,
  });

  const screenWidth = useScreenSize();

  const itemsToShow = useMemo(() => {
    if (screenWidth < 645) return 1;
    if (screenWidth >= 645 && screenWidth < 1024) return 2;
    if (screenWidth >= 645) return 3;
  }, [screenWidth]);

  if ((articleContent || []).length <= 0) return null;

  return (
    <Container>
      <Title>{articlesCarouselTitle ? articlesCarouselTitle : 'News'}</Title>
      {/*
      // @ts-ignore */}
      <Carousel
        // breakPoints={breakPoints}
        itemsToShow={itemsToShow}
        pagination={false}
        showArrows={false}
        itemPadding={[0, 6, 0, 6]}
        outerSpacing={outerSpacing ?? 16}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        style={{
          touchAction: 'pan-y', // Allows vertical scroll until explicitly prevented
        }}
      >
        {articleContent?.map((article) => (
          <React.Fragment key={article.attributes.slug}>
            <ArticleItem props={article} groupId={groupId} isCarousel />
          </React.Fragment>
        ))}
      </Carousel>
    </Container>
  );
};

export default observer(ArticlesCarousel);
